module.exports = __webpack_public_path__ + "static/img/layer3.81e11f2a.png";